export default  function isNumber(evt)  {
    const re = /^[0-9\b-]+$/;
    if (evt === '' || re.test(evt)) {
       return true
    }
    return false
  }